import { userAgentFromString } from 'next/server'
import { DeviceTypeEnum } from 'shared/enums/device-type-enum'

type NextUserAgentDeviceType = 'console' | 'mobile' | 'tablet' | 'smarttv' | 'wearable' | 'embedded'

const normalizedServerDeviceTypes: Partial<Record<NextUserAgentDeviceType, DeviceTypeEnum>> = {
  mobile: DeviceTypeEnum.Mobile,
  tablet: DeviceTypeEnum.Tablet,
}

export const getServerDeviceType = (userAgentHeader?: string | null): DeviceTypeEnum => {
  const deviceType = userAgentFromString(userAgentHeader ?? undefined).device.type as
    | NextUserAgentDeviceType
    | undefined

  if (deviceType === undefined) {
    return DeviceTypeEnum.Desktop
  }

  return normalizedServerDeviceTypes[deviceType] ?? DeviceTypeEnum.Unknown
}
